import { cn } from "../lib/utils";

export function PageLayout({
  title,
  subtitle,
  icon: Icon,
  iconBg = "bg-emerald-500/10 dark:bg-emerald-500/20",
  iconColor = "text-emerald-600 dark:text-emerald-400",
  children,
  actions,
  className,
  maxWidth = "max-w-none",
  ...props
}) {
  return (
    <div className={cn("mx-auto flex h-full w-full flex-col overflow-hidden px-4 sm:px-6 md:px-8 py-5", maxWidth, className)} {...props}>
      {(title || subtitle || actions) && (
        <div className="flex flex-col gap-4 border-b border-border/60 pb-4 sm:flex-row sm:items-center sm:justify-between shrink-0">
            <div className="min-w-0">
              {title && <h2 className="text-xl sm:text-2xl font-extrabold tracking-tight text-foreground">{title}</h2>}
              {subtitle && <p className="text-xs sm:text-sm text-muted-foreground mt-0.5 font-medium">{subtitle}</p>}
            </div>
          {actions && <div className="flex shrink-0 items-center gap-2.5 flex-wrap">{actions}</div>}
        </div>
      )}
      <div className="mt-4 flex-1 min-h-0 overflow-y-auto space-y-4 pr-1">{children}</div>
    </div>
  );
}

